export enum VoiceActionTypes {
  GET_VOICES_PENDING = '@@voice/GET_VOICES_PENDING',
  GET_VOICES_SUCCESS = '@@voice/GET_VOICES_SUCCESS',
  GET_VOICES_ERROR = '@@voice/GET_VOICES_ERROR',
}
